// images
import blogImg1 from "../images/blog/santalucia.png";
import blogImg2 from "../images/blog/repelon.png";
import blogImg3 from "../images/blog/manati.png";

import blogImg4 from "../images/blog/img-4.jpg";
import blogImg5 from "../images/blog/img-5.jpg";
import blogImg6 from "../images/blog/img-6.jpg";

import blogImg7 from "../images/blog/img-7.jpg";
import blogImg8 from "../images/blog/img-8.jpg";
import blogImg9 from "../images/blog/img-9.jpg";

import blogImg10 from "../images/blog/img-10.jpg";
import blogImg11 from "../images/blog/img-11.jpg";
import blogImg12 from "../images/blog/img-12.jpg";

import blogImg13 from "../images/blog/img-13.jpg";
import blogImg14 from "../images/blog/img-14.jpg";
import blogImg15 from "../images/blog/img-15.jpg";

import blogAvaterImg1 from "../images/blog/blog-avater/logopeq.png";
import blogAvaterImg2 from "../images/blog/blog-avater/logopeq.png";
import blogAvaterImg3 from "../images/blog/blog-avater/logopeq.png";

import blogSingleImg1 from "../images/blog/Santa lucía .jpg";
import blogSingleImg2 from "../images/blog/Repelón.jpg";
import blogSingleImg3 from "../images/blog/Manatí.jpg";

import blogSingleImg4 from "../images/blog/4.jpg";
import blogSingleImg5 from "../images/blog/5.jpg";
import blogSingleImg6 from "../images/blog/6.jpg";

import blogSingleImg7 from "../images/blog/7.jpg";
import blogSingleImg8 from "../images/blog/8.jpg";
import blogSingleImg9 from "../images/blog/9.jpg";

import blogSingleImg10 from "../images/blog/10.jpg";
import blogSingleImg11 from "../images/blog/11.jpg";
import blogSingleImg12 from "../images/blog/12.jpg";

import blogSingleImg13 from "../images/blog/13.jpg";
import blogSingleImg14 from "../images/blog/14.jpg";
import blogSingleImg15 from "../images/blog/15.jpg";



const blogs = [
    {
        id: '1',
        title: 'Santa Lucía.',
        screens: blogImg1,
        description: 'Fiestas, tradición y baile se enmarcan en un mismo lugar.',
        author: 'DigniCO',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg1,
        create_at: 'Nov,24',
        blogSingleImg:blogSingleImg1, 
        comment:'',
        blClass:'format-standard-image',
    },
    {
        id: '2',
        title: 'Repelón.',
        screens: blogImg2,
        description: 'Llegó a ser conocida como la despensa agrícola del Atlántico',
        author: 'DigniCO',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg2,
        create_at: 'Nov,24',
        blogSingleImg:blogSingleImg2, 
        comment:'',
        blClass:'format-standard-image',
    },
    {
        id: '3',
        title: 'Manatí.',
        screens: blogImg3,
        description: 'Se dice que originalmente estas tierras eran conocidas como Mahabana.',
        author: 'DigniCo',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg3,
        create_at: '18 AUG,21',
        blogSingleImg:blogSingleImg3,
        comment:'',
        blClass:'format-video',
    },
    {
        id: '4',
        title: 'Let’s Save The Rare Birds From Hunting.',
        screens: blogImg4,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet autem beatae errodio.',
        author: 'Jenefer Willy',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg1,
        create_at: '14 AUG,21',
        blogSingleImg:blogSingleImg4, 
        comment:'35',
        blClass:'format-standard-image',
    },
    {
        id: '5',
        title: 'Don’t Shoot The Royel Tiger With Your Gun.',
        screens: blogImg5,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet autem beatae errodio.',
        author: 'Konal Biry',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg2,
        create_at: '16 AUG,21',
        blogSingleImg:blogSingleImg5, 
        comment:'80',
        blClass:'format-standard-image',
    },
    {
        id: '6',
        title: 'Don’t be a thief, save coral reef Stop Killing The Reef.',
        screens: blogImg6,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet autem beatae errodio.',
        author: 'Jenefer Willy',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg3,
        create_at: '18 AUG,21',
        blogSingleImg:blogSingleImg6,
        comment:'95',
        blClass:'format-video',
    },
    {
        id: '7',
        title: 'Don’t treat oceans as universal garbage cans',
        screens: blogImg7,
        description: 'Don’t treat oceans as universal garbage cans',
        author: 'Jenefer Willy',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg1,
        create_at: '14 AUG,21',
        blogSingleImg:blogSingleImg7, 
        comment:'35',
        blClass:'format-standard-image',
    },
    {
        id: '8',
        title: 'The sun and the sand makes beaches beautiful',
        screens: blogImg8,
        description: 'The sun and the sand makes beaches beautiful',
        author: 'Konal Biry',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg2,
        create_at: '16 AUG,21',
        blogSingleImg:blogSingleImg8, 
        comment:'80',
        blClass:'format-standard-image',
    },
    {
        id: '9',
        title: 'Don’t be a thief, save coral reef Stop Killing The Reef.',
        screens: blogImg9,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet autem beatae errodio.',
        author: 'Jenefer Willy',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg3,
        create_at: '18 AUG,21',
        blogSingleImg:blogSingleImg9,
        comment:'95',
        blClass:'format-video',
    },
    {
        id: '10',
        title: 'Everything you need to know about COVID-19 vaccine',
        screens: blogImg10,
        description: 'Don’t treat oceans as universal garbage cans',
        author: 'Jenefer Willy',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg1,
        create_at: '14 AUG,21',
        blogSingleImg:blogSingleImg10, 
        comment:'35',
        blClass:'format-standard-image',
    },
    {
        id: '11',
        title: 'Coronavirus India cases and latest updates',
        screens: blogImg11,
        description: 'The sun and the sand makes beaches beautiful',
        author: 'Konal Biry',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg2,
        create_at: '16 AUG,21',
        blogSingleImg:blogSingleImg11, 
        comment:'80',
        blClass:'format-standard-image',
    },
    {
        id: '12',
        title: 'WHO issues clinical case definition of long COVID',
        screens: blogImg12,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet autem beatae errodio.',
        author: 'Jenefer Willy',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg3,
        create_at: '18 AUG,21',
        blogSingleImg:blogSingleImg12,
        comment:'95',
        blClass:'format-video',
    },
    {
        id: '13',
        title: 'Green is for hope just as gray is for death.',
        screens: blogImg13,
        description: 'Don’t treat oceans as universal garbage cans',
        author: 'Jenefer Willy',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg1,
        create_at: '14 AUG,21',
        blogSingleImg:blogSingleImg13, 
        comment:'35',
        blClass:'format-standard-image',
    },
    {
        id: '14',
        title: 'Clean and Green Means No One is Lean.',
        screens: blogImg14,
        description: 'The sun and the sand makes beaches beautiful',
        author: 'Konal Biry',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg2,
        create_at: '16 AUG,21',
        blogSingleImg:blogSingleImg14, 
        comment:'80',
        blClass:'format-standard-image',
    },
    {
        id: '15',
        title: 'By recycling, you can change tomorrow, today.',
        screens: blogImg15,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet autem beatae errodio.',
        author: 'Jenefer Willy',
        authorTitle:'volunteer',
        authorImg:blogAvaterImg3,
        create_at: '18 AUG,21',
        blogSingleImg:blogSingleImg15,
        comment:'95',
        blClass:'format-video',
    },
];

export default blogs;